import { render, staticRenderFns } from "./Template220.vue?vue&type=template&id=2d100432"
import script from "./Template220.vue?vue&type=script&lang=js"
export * from "./Template220.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports